let interval1 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    if(window.location.href === 'https://www.onetoonemanufacturing.com/products/collegiate-rack' || 
        window.location.href === 'https://www.onetoonemanufacturing.com/products/half-rack' ||
        window.location.href === 'https://www.onetoonemanufacturing.com/products/power-rack') {
      $('.product-form__variants').after($('#avpoptions-container__v2'));
    } else if ($('.product-form__variants').length) {
      $('.product-form__variants').before($('#avpoptions-container__v2'));
    } else {
      $('.product-form__info-list').after($('#avpoptions-container__v2'));
    }
    clearInterval(interval1);
  }
}, 100);

function forceQuitInterval(){
  clearInterval(interval1);
}

setTimeout(forceQuitInterval, 10000);


// Start: Plus add charge into price of product
let formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

let originPriceText = null;
let originPrice = null;
let interval3 = setInterval(function () {
  let ap_elements = document.querySelector('#avpoptions-container__v2');
  if (ap_elements) {
    if (!originPriceText) {
      originPriceText = $('.product-form__info-item .price')[0].innerHTML;
      originPrice = parseFloat($('.product-form__info-item .price')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
    }	
    if (originPriceText && originPrice && $('#avp-productoption-total-add').is(':visible')){
      let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
      let newPrice = originPrice + addChargePrice;
      $('.product-form__info-item .avpo-price.price')[0].innerHTML = formatter.format(newPrice) + ' CAD';
      $($('.product-form__info-item .price')[0]).css('display', 'none');

    } else {
      $('.product-form__info-item .avpo-price.price')[0].innerHTML = originPriceText;
      $($('.product-form__info-item .price')[0]).css('display', 'none');
    }
  } 
}, 100);
// End: Plus add charge into price of product

// Start: Plus add charge into price of product
// let formatter = new Intl.NumberFormat('en-US', {
//   style: 'currency',
//   currency: 'USD',
// });

// let interval = setInterval(function () {
//   let originPriceText = null;
//   let originPrice = null;
//   let ap_elements = document.querySelector('#avpoptions-container__v2');
//   if (ap_elements) {
//     if (!originPriceText) {
//       originPriceText = $('.h1-style.price')[0].innerHTML;
//       originPrice = parseFloat($('.h1-style.price')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
//     }	
//     if ($('#avp-productoption-total-add').is(':visible')){
//       let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
//       let newPrice = originPrice + addChargePrice;
//       $('.avpo-price.h1-style.price')[0].innerHTML = formatter.format(newPrice);
//       $($('.h1-style.price')[0]).css('display', 'none');
//     } else {
//       $('.avpo-price.h1-style.price')[0].innerHTML = originPriceText;
//       $($('.h1-style.price')[0]).css('display', 'none');
//     }
//   } 
// }, 100);
// End: Plus add charge into price of product

